// import { X, Check, Mail, User, Phone, Calendar, ArrowRight, Globe } from 'lucide-react';
// import './LeadModal.css';
// import { useEffect, useState } from 'react';
// import { useCookies } from 'react-cookie';
// import { useSelector } from 'react-redux';
// import mobileNoValidation, { countryCodeList, emailValidation } from "../../../common/common"
// import { apiList, invokeApi } from '../../../apis/apiServices';
// import { config } from '../../../config/config';
// import { Bounce, toast } from 'react-toastify';
// import { Link } from 'react-router-dom';

// const LeadForm = ({ isOpen, onClose, leadSource, propertyId, productUrl, leadProvided }) => {
//     const [cookies] = useCookies();
//     const { userData, userError } = useSelector(
//         (state) => state.user
//     );
//     const [formData, setFormData] = useState({
//         customerName: '',
//         countryCode: '91',
//         mobileNumber: '',
//         email: '',
//         scheduleDateTime: '',
//     });
//     let mobileValidate = mobileNoValidation(formData.mobileNumber);
//     let emailValidate = emailValidation(formData.email);
//     const [errors, setErrors] = useState({});
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [animate, setAnimate] = useState(false);

//     useEffect(() => {
//         if (isOpen) {
//             document.body.style.overflow = 'hidden';
//             setTimeout(() => setAnimate(true), 50);
//         } else {
//             document.body.style.overflow = 'auto';
//             setAnimate(false);
//         }

//         return () => {
//             document.body.style.overflow = 'auto';
//         };
//     }, [isOpen]);

//     const validateForm = () => {
//         const newErrors = {};

//         if (!formData.customerName.trim()) {
//             newErrors.customerName = 'Full name is required';
//         }

//         if (!formData.email.trim()) {
//             newErrors.email = 'Email is required';
//         } else if (!emailValidate) {
//             newErrors.email = 'Email is invalid';
//         }

//         if (!formData.mobileNumber.trim()) {
//             newErrors.mobileNumber = 'Mobile number is required';
//         } else if (!mobileValidate) {
//             newErrors.mobileNumber = 'Mobile number must be 10 digits';
//         }

//         if (!formData.scheduleDateTime.trim()) {
//             newErrors.scheduleDateTime = 'Please select a date and time';
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({
//             ...formData,
//             [name]: value
//         });

//         // Clear error message when user types
//         if (errors[name]) {
//             setErrors({
//                 ...errors,
//                 [name]: ''
//             });
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setIsSubmitting(true);

//             let params = {
//                 email: formData.email,
//                 customerName: formData.customerName,
//                 mobileNumber: formData.mobileNumber,
//                 propertyId: propertyId,
//                 leadSource: leadSource,
//                 leadType: "Own",
//                 scheduleDateTime: formData.scheduleDateTime,
//                 countryCode: formData.countryCode,
//                 productUrl,
//             };
//             const response = await invokeApi(
//                 config.apiDomains + apiList.addLead,
//                 params,
//                 cookies
//             );
//             if (response.status >= 200 && response.status < 300) {
//                 if (response.data.responseCode === "200") {
//                     toast.success(
//                         "Thank you for showing interest we will contact you soon",
//                         {
//                             position: "top-center",
//                             autoClose: 5000,
//                             hideProgressBar: false,
//                             closeOnClick: true,
//                             pauseOnHover: true,
//                             draggable: true,
//                             progress: undefined,
//                             theme: "light",
//                             transition: Bounce,
//                         }
//                     );
//                     resetForm();
//                     onClose();
//                     // leadProvided(propertyId);
//                 } else {
//                     toast.error("Sorry Something went wrong", {
//                         position: "top-center",
//                         autoClose: 5000,
//                         hideProgressBar: false,
//                         closeOnClick: true,
//                         pauseOnHover: true,
//                         draggable: true,
//                         progress: undefined,
//                         theme: "light",
//                         transition: Bounce,
//                     });
//                     setIsSubmitting(false);
//                 }
//             } else if (response.status === 400) {
//                 toast.info(response.data.responseMessage, {
//                     position: "top-center",
//                     autoClose: 5000,
//                     hideProgressBar: false,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     progress: undefined,
//                     theme: "light",
//                     transition: Bounce,
//                 });
//                 setIsSubmitting(false);
//             } else {
//                 toast.error("Sorry Something went wrong", {
//                     position: "top-center",
//                     autoClose: 5000,
//                     hideProgressBar: false,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     progress: undefined,
//                     theme: "light",
//                     transition: Bounce,
//                 });
//                 setIsSubmitting(false);
//             }
//         }
//     };

//     const resetForm = () => {
//         setFormData({
//             customerName: '',
//             countryCode: '91',
//             mobileNumber: '',
//             email: '',
//             scheduleDateTime: '',
//         });
//         setErrors({});
//         setIsSubmitted(false);
//     };

//     useEffect(() => {
//         if (userError) {
//             alert(
//                 "Something went wrong while fetching user details. Please try again later!"
//             );
//         }
//     }, [userError]);

//     if (!isOpen) return null;
//     return (
//         <div className={`lead-modal-overlay ${animate ? 'active' : ''}`} onClick={onClose}>
//             <div className={`lead-modal-container ${animate ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>
//                 <button className="lead-modal-close" onClick={onClose}>
//                     <X size={24} />
//                 </button>

//                 <div className="lead-modal-content">
//                     {!isSubmitted ? (
//                         <>
//                             <div className="lead-modal-header">
//                                 <div className="lead-modal-badge">Exclusive Offer</div>
//                                 <h2 className="lead-modal-title">Interested? Let’s Connect!</h2>
//                                 <p className="lead-modal-subtitle">
//                                     Fill out the form below and our real estate expert will get in touch with you shortly.
//                                 </p>
//                             </div>

//                             <form onSubmit={handleSubmit} className="lead-modal-form">
//                                 <div className="form-group">
//                                     <label htmlFor="customerName">Full Name</label>
//                                     <div className="input-wrapper">
//                                         <User size={18} className="input-icon" />
//                                         <input
//                                             type="text"
//                                             id="customerName"
//                                             name="customerName"
//                                             value={formData.customerName}
//                                             onChange={handleChange}
//                                             placeholder="John Doe"
//                                             className={errors.customerName ? 'error' : ''}
//                                         />
//                                     </div>
//                                     {errors.customerName && <span className="error-message">{errors.customerName}</span>}
//                                 </div>

//                                 <div className="form-group">
//                                     <label htmlFor="email">Email Address</label>
//                                     <div className="input-wrapper">
//                                         <Mail size={18} className="input-icon" />
//                                         <input
//                                             type="email"
//                                             id="email"
//                                             name="email"
//                                             value={formData.email}
//                                             onChange={handleChange}
//                                             placeholder="johndoe@example.com"
//                                             className={errors.email ? 'error' : ''}
//                                         />
//                                     </div>
//                                     {errors.email && <span className="error-message">{errors.email}</span>}
//                                 </div>

//                                 <div className="form-group">
//                                     <label htmlFor="mobileNumber">Mobile Number</label>
//                                     <div className="phone-input-container">
//                                         <div className="country-code-wrapper">
//                                             <select
//                                                 id="countryCode"
//                                                 name="countryCode"
//                                                 value={formData.countryCode}
//                                                 onChange={handleChange}
//                                                 className="country-code-select"
//                                             >
//                                                 {countryCodeList.map((country) => (
//                                                     <option key={country.code} value={country.code}>
//                                                         +{country.code} {country.iso}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                         <div className="phone-wrapper">
//                                             <Phone size={18} className="input-icon phone-icon" />
//                                             <input
//                                                 type="tel"
//                                                 id="mobileNumber"
//                                                 name="mobileNumber"
//                                                 value={formData.mobileNumber}
//                                                 onChange={handleChange}
//                                                 placeholder="123 456 7890"
//                                                 className={errors.mobileNumber ? 'error' : ''}
//                                             />
//                                         </div>
//                                     </div>
//                                     {errors.mobileNumber && <span className="error-message">{errors.mobileNumber}</span>}
//                                 </div>

//                                 <div className="form-group">
//                                     <label htmlFor="scheduleDateTime">Schedule Date & Time</label>
//                                     <div className="input-wrapper">
//                                         <Calendar size={18} className="input-icon" />
//                                         <input
//                                             type="datetime-local"
//                                             id="scheduleDateTime"
//                                             name="scheduleDateTime"
//                                             value={formData.scheduleDateTime}
//                                             onChange={handleChange}
//                                             className={errors.scheduleDateTime ? 'error' : ''}
//                                         />
//                                     </div>
//                                     {errors.scheduleDateTime && <span className="error-message">{errors.scheduleDateTime}</span>}
//                                 </div>

//                                 {/* <div className="form-group">
//                                     <label htmlFor="message">Your Message (Optional)</label>
//                                     <textarea
//                                         id="message"
//                                         name="message"
//                                         value={formData.message}
//                                         onChange={handleChange}
//                                         placeholder="I'm interested in scheduling a viewing for this property..."
//                                         rows="3"
//                                     ></textarea>
//                                 </div> */}

//                                 <button
//                                     type="submit"
//                                     className="submit-button"
//                                     disabled={isSubmitting}
//                                 >
//                                     {isSubmitting ? (
//                                         <span className="button-loading">Processing...</span>
//                                     ) : (
//                                         <>
//                                             <span>Get Property Details</span>
//                                             <ArrowRight size={18} />
//                                         </>
//                                     )}
//                                 </button>

//                                 <p className="privacy-note">
//                                     By submitting this form, you agree to our <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms-conditions">Terms of Service</Link>.
//                                 </p>
//                             </form>
//                         </>
//                     ) : (
//                         <div className="lead-modal-success">
//                             <div className="success-icon">
//                                 <Check size={32} />
//                             </div>
//                             <h2>Thank You!</h2>
//                             <p>Your information has been submitted successfully. Our agent will contact you shortly for your property viewing at your scheduled time.</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default LeadForm





















import { X, Check, Mail, User, Phone, Calendar, ArrowRight, Globe } from 'lucide-react';
import {
    Box,
    Modal,
    IconButton,
    Typography,
    TextField,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Alert,
    CircularProgress,
    Link
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import mobileNoValidation, { countryCodeList, emailValidation } from "../../../common/common";
import { apiList, invokeApi } from '../../../apis/apiServices';
import { config } from '../../../config/config';
import { Bounce, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const LeadForm = ({ isOpen, onClose, leadSource, propertyId, productUrl, leadProvided }) => {
    const [cookies] = useCookies();
    const navigate = useNavigate();
    const { userData, userError } = useSelector((state) => state.user);

    const [formData, setFormData] = useState({
        customerName: '',
        countryCode: '91',
        mobileNumber: '',
        email: '',
        scheduleDateTime: '',
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    const validateForm = () => {
        const newErrors = {};
        const mobileValidate = mobileNoValidation(formData.mobileNumber);
        const emailValidate = emailValidation(formData.email);

        if (!formData.customerName.trim()) {
            newErrors.customerName = 'Full name is required';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!emailValidate) {
            newErrors.email = 'Please enter a valid email address';
        }

        if (!formData.mobileNumber.trim()) {
            newErrors.mobileNumber = 'Mobile number is required';
        } else if (!mobileValidate) {
            newErrors.mobileNumber = 'Please enter a valid 10-digit mobile number';
        }

        if (!formData.scheduleDateTime.trim()) {
            newErrors.scheduleDateTime = 'Please select a date and time';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setIsSubmitting(true);

            let params = {
                email: formData.email,
                customerName: formData.customerName,
                mobileNumber: formData.mobileNumber,
                propertyId: propertyId,
                leadSource: leadSource,
                leadType: "Own",
                scheduleDateTime: formData.scheduleDateTime,
                countryCode: formData.countryCode,
                productUrl,
            };

            const response = await invokeApi(
                config.apiDomains + apiList.addLead,
                params,
                cookies
            );

            if (response.status >= 200 && response.status < 300) {
                if (response.data.responseCode === "200") {
                    toast.success(
                        "Thank you for showing interest. We will contact you soon!",
                        {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            transition: Bounce,
                        }
                    );
                    resetForm();
                    onClose();
                } else {
                    toast.error("Sorry, something went wrong. Please try again.", {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                    setIsSubmitting(false);
                }
            } else if (response.status === 400) {
                toast.info(response.data.responseMessage, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                setIsSubmitting(false);
            } else {
                toast.error("Sorry, something went wrong. Please try again.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                setIsSubmitting(false);
            }
        }
    };

    const resetForm = () => {
        setFormData({
            customerName: '',
            countryCode: '91',
            mobileNumber: '',
            email: '',
            scheduleDateTime: '',
        });
        setErrors({});
        setIsSubmitted(false);
    };

    useEffect(() => {
        if (userError) {
            toast.error(
                "Something went wrong while fetching user details. Please try again later!",
                {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                }
            );
        }
    }, [userError]);

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="lead-form-modal"
            aria-describedby="lead-form-description"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
                backdropFilter: 'blur(4px)',
            }}
        >
            <Box
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 3,
                    boxShadow: 24,
                    maxWidth: 500,
                    width: '100%',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    position: 'relative',
                    scrollbarWidth: 'thin',
                    animation: isOpen ? 'modalSlideIn 0.3s ease' : 'none',
                    '@keyframes modalSlideIn': {
                        '0%': {
                            opacity: 0,
                            transform: 'translateY(-20px) scale(0.95)',
                        },
                        '100%': {
                            opacity: 1,
                            transform: 'translateY(0) scale(1)',
                        },
                    },
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Close Button */}
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        zIndex: 1,
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.08)',
                        },
                    }}
                >
                    <X size={20} />
                </IconButton>

                {/* Modal Content */}
                <Box sx={{ p: { xs: 3, sm: 4 } }}>
                    {!isSubmitted ? (
                        <>
                            {/* Header */}
                            <Box sx={{ textAlign: 'center', mb: 4 }}>
                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        backgroundColor: 'rgba(220, 38, 38, 0.1)',
                                        color: '#dc2626',
                                        px: 2,
                                        py: 0.5,
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '0.5px',
                                        mb: 2,
                                    }}
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            width: 6,
                                            height: 6,
                                            backgroundColor: '#dc2626',
                                            borderRadius: '50%',
                                            mr: 1,
                                            animation: 'pulse 1.5s infinite',
                                            '@keyframes pulse': {
                                                '0%, 100%': {
                                                    opacity: 1,
                                                    transform: 'scale(1)',
                                                },
                                                '50%': {
                                                    opacity: 0.7,
                                                    transform: 'scale(1.2)',
                                                },
                                            },
                                        }}
                                    />
                                    Exclusive Offer
                                </Box>

                                <Typography
                                    id="lead-form-modal"
                                    variant="h4"
                                    sx={{
                                        fontWeight: 700,
                                        color: '#111827',
                                        mb: 1.5,
                                        fontSize: { xs: '24px', sm: '28px' },
                                    }}
                                >
                                    Interested? Let's Connect!
                                </Typography>

                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: '#6b7280',
                                        fontSize: { xs: '14px', sm: '15px' },
                                        lineHeight: 1.6,
                                        maxWidth: '400px',
                                        mx: 'auto',
                                    }}
                                >
                                    Fill out the form below and our real estate expert will get in touch with you shortly.
                                </Typography>
                            </Box>

                            {/* Form */}
                            <Box
                                component="form"
                                onSubmit={handleSubmit}
                                sx={{
                                    '& .MuiFormControl-root': {
                                        mb: 2.5,
                                    },
                                }}
                            >
                                {/* Full Name */}
                                <TextField
                                    fullWidth
                                    label="Full Name"
                                    name="customerName"
                                    value={formData.customerName}
                                    onChange={handleChange}
                                    placeholder="John Doe"
                                    error={!!errors.customerName}
                                    helperText={errors.customerName}
                                    InputProps={{
                                        startAdornment: (
                                            <User
                                                size={18}
                                                style={{ marginRight: 12, color: '#9ca3af' }}
                                            />
                                        ),
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#dc2626',
                                            },
                                        },
                                    }}
                                />

                                {/* Email */}
                                <TextField
                                    fullWidth
                                    type="email"
                                    label="Email Address"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="johndoe@example.com"
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    InputProps={{
                                        startAdornment: (
                                            <Mail
                                                size={18}
                                                style={{ marginRight: 12, color: '#9ca3af' }}
                                            />
                                        ),
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#dc2626',
                                            },
                                        },
                                    }}
                                />

                                {/* Mobile Number */}
                                <Box sx={{ mb: 2.5 }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: 500,
                                            mb: 1,
                                            color: '#374151',
                                            fontSize: '14px',
                                        }}
                                    >
                                        Mobile Number
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        {/* Country Code */}
                                        <FormControl sx={{ minWidth: 120 }}>
                                            <Select
                                                name="countryCode"
                                                value={formData.countryCode}
                                                onChange={handleChange}
                                                sx={{
                                                    height: '56px',
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: errors.mobileNumber ? '#ef4444' : '#d1d5db',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#dc2626',
                                                    },
                                                }}
                                            >
                                                {countryCodeList.map((country) => (
                                                    <MenuItem key={country.code} value={country.code}>
                                                        +{country.code} {country.iso}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        {/* Phone Number */}
                                        <TextField
                                            fullWidth
                                            type="tel"
                                            name="mobileNumber"
                                            value={formData.mobileNumber}
                                            onChange={handleChange}
                                            placeholder="123 456 7890"
                                            error={!!errors.mobileNumber}
                                            helperText={errors.mobileNumber}
                                            InputProps={{
                                                startAdornment: (
                                                    <Phone
                                                        size={18}
                                                        style={{ marginRight: 12, color: '#9ca3af' }}
                                                    />
                                                ),
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#dc2626',
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </Box>

                                {/* Schedule Date & Time */}
                                <TextField
                                    fullWidth
                                    type="datetime-local"
                                    label="Schedule Date & Time"
                                    name="scheduleDateTime"
                                    value={formData.scheduleDateTime}
                                    onChange={handleChange}
                                    error={!!errors.scheduleDateTime}
                                    helperText={errors.scheduleDateTime}
                                    InputProps={{
                                        startAdornment: (
                                            <Calendar
                                                size={18}
                                                style={{ marginRight: 12, color: '#9ca3af' }}
                                            />
                                        ),
                                        sx: {
                                            '& input[type="datetime-local"]': {
                                                cursor: 'pointer',
                                            },
                                        },
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#dc2626',
                                            },
                                        },
                                    }}
                                />

                                {/* Submit Button */}
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    disabled={isSubmitting}
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        py: 1.5,
                                        backgroundColor: '#dc2626',
                                        fontWeight: 600,
                                        fontSize: '16px',
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        '&:hover': {
                                            backgroundColor: '#b91c1c',
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 6px 20px rgba(220, 38, 38, 0.3)',
                                        },
                                        '&:disabled': {
                                            backgroundColor: '#fca5a5',
                                        },
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    {isSubmitting ? (
                                        <CircularProgress size={24} sx={{ color: 'white' }} />
                                    ) : (
                                        <>
                                            Get Property Details
                                            <ArrowRight size={18} style={{ marginLeft: 8 }} />
                                        </>
                                    )}
                                </Button>

                                {/* Privacy Note */}
                                <Typography
                                    variant="body2"
                                    sx={{
                                        textAlign: 'center',
                                        color: '#6b7280',
                                        fontSize: '12px',
                                        mt: 2,
                                    }}
                                >
                                    By submitting this form, you agree to our{' '}
                                    <Link
                                        href="/privacy-policy"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/privacy-policy');
                                            onClose();
                                        }}
                                        sx={{
                                            color: '#dc2626',
                                            textDecoration: 'none',
                                            fontWeight: 500,
                                            cursor: 'pointer',
                                            '&:hover': {
                                                textDecoration: 'underline',
                                            },
                                        }}
                                    >
                                        Privacy Policy
                                    </Link>{' '}
                                    and{' '}
                                    <Link
                                        href="/terms-conditions"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/terms-conditions');
                                            onClose();
                                        }}
                                        sx={{
                                            color: '#dc2626',
                                            textDecoration: 'none',
                                            fontWeight: 500,
                                            cursor: 'pointer',
                                            '&:hover': {
                                                textDecoration: 'underline',
                                            },
                                        }}
                                    >
                                        Terms of Service
                                    </Link>
                                    .
                                </Typography>
                            </Box>
                        </>
                    ) : (
                        /* Success State */
                        <Box sx={{ textAlign: 'center', py: 4 }}>
                            <Box
                                sx={{
                                    width: 80,
                                    height: 80,
                                    backgroundColor: '#10b981',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mx: 'auto',
                                    mb: 3,
                                    animation: 'scaleIn 0.5s ease',
                                    '@keyframes scaleIn': {
                                        '0%': {
                                            transform: 'scale(0)',
                                        },
                                        '100%': {
                                            transform: 'scale(1)',
                                        },
                                    },
                                }}
                            >
                                <Check size={36} color="white" />
                            </Box>

                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: 700,
                                    color: '#111827',
                                    mb: 2,
                                }}
                            >
                                Thank You!
                            </Typography>

                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#6b7280',
                                    lineHeight: 1.6,
                                    maxWidth: '400px',
                                    mx: 'auto',
                                    mb: 4,
                                }}
                            >
                                Your information has been submitted successfully. Our agent will contact you shortly for your property viewing at your scheduled time.
                            </Typography>

                            <Button
                                variant="outlined"
                                onClick={onClose}
                                sx={{
                                    borderColor: '#dc2626',
                                    color: '#dc2626',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    px: 4,
                                    '&:hover': {
                                        backgroundColor: '#fee2e2',
                                        borderColor: '#dc2626',
                                    },
                                }}
                            >
                                Close
                            </Button>
                        </Box>
                    )}
                </Box>
            </Box>
        </Modal>
    );
};

export default LeadForm;